import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "tr" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "案由", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "tr" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "案号", -1)
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "立案日期", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "tr" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "开庭时间", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "结束日期", -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "tr" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "承办部门", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "法院", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "tr" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "承办法官", -1)
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "法官助理", -1)
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "tr" }
const _hoisted_35 = { class: "item" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "案件类型", -1)
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "item" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "案件状态", -1)
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "tr" }
const _hoisted_42 = { class: "item" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "公诉人/原告/上诉人/申请人", -1)
const _hoisted_44 = { class: "value" }
const _hoisted_45 = { class: "item" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "被告人/被告/被上诉人/被申请人", -1)
const _hoisted_47 = { class: "value" }
const _hoisted_48 = { class: "tr" }
const _hoisted_49 = { class: "item" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "第三人", -1)
const _hoisted_51 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.d.caseReason || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.d.caseNo || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.toDate(_ctx.d.lianDate,"YYYY-MM-DD")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.toDate(_ctx.d.holdDate,"YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.toDate(_ctx.d.finishDate,"YYYY-MM-DD")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.d.undertakeDep || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.d.court || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.d.judger || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.d.assistant || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.d.caseType || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.d.caseStatus || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.prosecutorList, (item, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index?'、':'') + _toDisplayString(item.name), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.defendantList, (item, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index?'、':'') + _toDisplayString(item.name), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _hoisted_50,
        _createElementVNode("div", _hoisted_51, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.outSiderList, (item, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(index?'、':'') + _toDisplayString(item.name), 1))
          }), 128))
        ])
      ])
    ])
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
}